



























// vue
import {Vue, Component} from 'vue-property-decorator';
import {State} from 'vuex-class';

@Component({

})
export default class App extends Vue {
  @State('companyInfo')
  public companyInfo!: any;

  @State('navInfo')
  public navInfo!: any[];

  // 页数
  public pageNumber: number = 1;

  get navShowList() {
    const start = (this.pageNumber - 1) * 4;
    const result = this.navInfo.slice(start, start + 4);
    return result;
  }

  // 上一页
  public pageUp() {
    if (this.pageNumber <= 1) {
      this.pageNumber = 1;
    } else {
      this.pageNumber--;
    }
  }

  // 下一页
  public pageDown() {
    const total = this.navInfo.length / 4;
    const totalPage = Math.ceil(total);

    if (this.pageNumber < totalPage) {
      this.pageNumber++;
    }
  }

  // 前往页面
  public toPage(item: any, index: number) {
    const {catType, id, outUrl} = item;
    if (outUrl) {
      if ((<string> outUrl).startsWith('http://') || (<string> outUrl).startsWith('https://')) {
        window.location.assign(outUrl);
      } else {
        window.location.assign('http://'.concat(outUrl));
      }

      return false;
    }

    switch (catType) {
      // 根目录
      case '0':
        this.$router.push({
          path: '/root-col',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 新闻列表
      case '1':
        this.$router.push({
          path: '/news',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 图文详情
      case '2':
        this.$router.push({
          path: '/news-article',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 留言反馈
      case '3':
        this.$router.push({
          path: '/advise',
        });
        break;
      // 留言反馈
      case '10':
        this.$router.push({
          path: '/',
        });
        break;
    }
  }
}
